import axios from "axios";
import Config from "../../config/";
import moment from 'moment';
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: {
      'Authorization': localStorage.getItem('token')
    }
  };
}

export function postFutureCatalog(datanya) {
    const url = `${ROOT_URL}featurecatalog`;

    const request = axios.post(
      url, datanya ,cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    return request;

}

export function updateFutureCatalog(datanya) {

  console.log(datanya.featureCatalogCode);
    const url = `${ROOT_URL}featurecatalog/${datanya.featureCatalogId}`;

    const request = axios.put(
      url, datanya ,cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    return request;

}

export function postFutureType(datanya) {
    const url = `${ROOT_URL}featuretype`;

    const request = axios.post(
      url, datanya ,cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    return request;

}

export function fetchCatalog() {
    const url = `${ROOT_URL}featurecatalogget`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function fetchUnsur(fcid) {
    const url = `${ROOT_URL}featuretypeget?fcid=${fcid}`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function fetchFeatureType(fcid, code) {
    const url = `${ROOT_URL}featuretypeproperty?fcid=${fcid}&code=${code}`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function fetchFeatureTypeByCode(code) {
    const url = `${ROOT_URL}featuretypegetbycode?code=${code}`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function deleteFT(ftid) {
    const url = `${ROOT_URL}featuretype/${ftid}`;
    const request = axios.delete(url, cekAuth());
    return request;
}


export function fetchxxx(ftid) {
    const url = `http://34.87.16.38/coba.gltf`;
    const request = axios.get(url);
    return request;
}

export function generateRDFAll() {
    const url = `${ROOT_URL}genfeaturecatalog`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function generateRDFCatalogOnly() {
    const url = `${ROOT_URL}genfeaturecatalogonly`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function generateRDFloop() {
    const url = `${ROOT_URL}genfeaturetypeloop`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function generateRDFloopx() {
    const url = `${ROOT_URL}genfeaturetypeloopx`;
    const request = axios.get(url, cekAuth());
    return request;
}
